module.exports = __webpack_public_path__ + "media/images/thumbnails/thumbs_textarea-aaf7c55a285920c8bf80022db61d2029.jpg";